/*
*   @site           Preloaded: Site
*   @function       Layout Controller
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Navigation
//-----------------------------------------------
export const NAV_CONFIG = {
  themes: 3,

  //Allowed colours for the flood fill
  allowed: ['night-sky', 'silver', 'lemon', 'mint', 'turquoise', 'blue', 'pink', 'burnt-orange', 'cerise', 'charcoal', 'white'],

  //Themes that default to the alt bar
  altBar: ['blue'],
};


//Maintains stroke thickness (increase for thicker strokes)
export const STROKE_CONSTANT = 500;